// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ibXEE3ABkJim3T {
  display: flex;
  position: fixed;
  z-index: -1;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--ds-background-neutral, #091e420f);
}
.deyzCTZFtKcARO {
  position: absolute;
  right: 66px;
  bottom: var(--ds-space-600, 48px);
  width: 351px;
  max-width: 30%;
  height: 332px;
}
@media only screen and (max-width: 750px) {
  .deyzCTZFtKcARO {
    display: none;
  }
}
.wnxj8ltw3NV_Zp {
  position: absolute;
  z-index: -1;
  bottom: var(--ds-space-0, 0px);
  width: 100%;
}
@media only screen and (max-width: 750px) {
  .wnxj8ltw3NV_Zp {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `ibXEE3ABkJim3T`,
	"people": `deyzCTZFtKcARO`,
	"curve": `wnxj8ltw3NV_Zp`
};
export default ___CSS_LOADER_EXPORT___;
